import type { Role } from '@/types';

import type { OrderStatus } from './types';

/** Internal all-orders view (ADR-0001 amendment 2026-06-25). Dealer is denied here;
 *  the Dealer-scoped order view is a separate later story. Field Installer is denied. */
export const ORDERS_ROLES: Role[] = ['super_admin', 'admin', 'operational_associate'];

/** Human page name surfaced in the access-denied toast. */
export const ORDERS_PAGE_NAME = 'Orders Management';

/** Allowed status transitions (ADR-0015). Non-sequential: order_placed may skip to delivered,
 *  shipped may move backward to order_placed. `delivered`/`cancelled` are final (empty = no moves). */
export const STATUS_TRANSITIONS: Record<OrderStatus, OrderStatus[]> = {
  // Pre-placement: no admin moves, but not final either (ADR-0015 Amendment 1).
  payment_processing: [],
  payment_failed: [],
  order_placed: ['shipped', 'delivered', 'cancelled'],
  shipped: ['order_placed', 'delivered', 'cancelled'],
  delivered: [],
  cancelled: [],
};

/** Delivered / Cancelled only. Not inferred from an empty transition list, which pre-placement
 *  statuses also have (ADR-0015 Amendment 1). */
export const isFinalStatus = (status: OrderStatus): boolean =>
  status === 'delivered' || status === 'cancelled';

/** Mirrors the backend's `PRE_PLACEMENT_ORDER_STATUSES`: payment not yet succeeded. Gates the
 *  view-only Order Detail (ADR-0015 Amendment 1). */
export const isPrePlacementStatus = (status: OrderStatus): boolean =>
  status === 'payment_processing' || status === 'payment_failed';

/** Story 102123 — server + FE share these so copy can't drift. */
export const INSTALLATION_PENDING_CODE = 'INSTALLATION_REQUEST_PENDING';
export const INSTALLATION_PENDING_MESSAGE =
  'Installation request is in pending status. Please approve or reject the installation request before changing the order status to Delivered.';
export const ORDER_STATUS_UPDATED_MESSAGE = 'Order status updated successfully.';
export const ORDER_CANCELLED_MESSAGE = 'Order cancelled successfully. Refund has been initiated.';

export const SUPPORT_TICKET_RAISED_MESSAGE = 'Support ticket raised successfully.';

/** Server + FE share these so copy can't drift (mirrors the installation-pending pair). */
export const OPEN_TICKET_LIMIT_CODE = 'OPEN_TICKET_LIMIT_REACHED';
export const OPEN_TICKET_LIMIT_MESSAGE =
  'Open Support ticket limit has reached the maximum. Please resolve existing tickets to create one.';
